"use strict";

exports.__esModule = true;
exports.SET_QUERY_PARAMETERS = exports.INIT_SSOAUTH = void 0;
const INIT_SSOAUTH = exports.INIT_SSOAUTH = "INIT_SSOAUTH";
const SET_QUERY_PARAMETERS = exports.SET_QUERY_PARAMETERS = "SET_QUERY_PARAMETERS";